import { TitleAndFileNames } from 'src/app/content/_components/_shared/mediaviewmodal/mediaviewmodal.component';
import { FileForPreview } from 'src/app/content/_components/_shared/preview-thumbnails/preview-thumbnail.type';

export abstract class MediaApiFunc {
  /**
   * @argument filepath - z.B. erfassung: 'name.png|name2.jpeg', rueckmeldung: '';
   */
  abstract parseMediaPath(...filepaths: string[]): TitleAndFileNames[];

  parseMediaPathWithTitle(...titledPath: TitleAndFilePath[]): TitleAndFileNames[] {
    return this.parseMediaPath(...titledPath.map(o => o.filepath));
  }

  abstract getApiFunctionMedia: FilesByNamesFn;
  abstract getApiFunctionMediaBig: FileByNameFn;
}

export interface IMediaApi {
  sources: TitleAndFileNames[];
  getApiFunctionMedia?: (fileNames?: string[], subfolder?: string) => Promise<FileForPreview[]>;
  getApiFunctionMediaBig?: (name: string) => Promise<string>;
}

export interface TitleAndFilePath {
  title: string;
  filepath: string;
}

export type FilesByNamesFn = (filenames: string[]) => Promise<FileForPreview[]>;
export type FileByNameFn = (name: string) => Promise<string>;
